import { constants } from '../../../helpers';
import {
  changeCancellationsFilterEndAccountingDate,
  changeCancellationsFilterStartAccountingDate,
  reportCancellationsFilterEndAccountingDateSelector,
  reportCancellationsFilterStartAccountingDateSelector,
} from '../../../state';
import { DateRangeFlexSalesProps } from '../../DateRangeFlexSales';
import ReportAccountingDateRangeFilter from '../../ReportFilters/filters/AccountingDateRangeFilter';

type AccountingDateRangeFilterProps = Pick<
  DateRangeFlexSalesProps<Date>,
  'spacing' | 'requiredIncomplete'
>;

const AccountingDateRangeFilter = (props: AccountingDateRangeFilterProps) => (
  <ReportAccountingDateRangeFilter
    {...props}
    maxDate={constants.reportCancellationsFilterRangeMaxDate}
    startDateSelector={reportCancellationsFilterStartAccountingDateSelector}
    endDateSelector={reportCancellationsFilterEndAccountingDateSelector}
    changeStartDateAction={changeCancellationsFilterStartAccountingDate}
    changeEndDateAction={changeCancellationsFilterEndAccountingDate}
  />
);

export default AccountingDateRangeFilter;
